import { createFileRoute } from "@tanstack/react-router"
import { TenantRoute } from "@/tenant"

export const Route = createFileRoute("/(user)/t/$tenantSlug")({
  component: RouteComponent,
})

function RouteComponent() {
  const { tenantSlug } = Route.useParams()

  return <TenantRoute tenantSlug={tenantSlug} />
}
